import React from "react";
import ReCAPTCHA from 'react-google-recaptcha'
import { Redirect, withRouter } from "react-router-dom"
import { Form, Icon, Input, Button, Tooltip, message,Checkbox, Typography, Select } from 'antd'
import { Auth, API } from "aws-amplify"
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"

import LoginBase from './LoginBase'
const { Paragraph } = Typography;

const queryString = require('query-string')

// Captcha key for prod/dev
const TEST_SITE_KEY = "6Ldb6fcZAAAAAAaa-8GLxt7RCVnB6GdKDu8tkNQj"


//Captcha KEY for Localhost:
//const TEST_SITE_KEY ="6LcsPdkUAAAAAAA4ACpozEKRtbGGQyfT_vrGNdxP"
class SignUpForm extends React.Component {

    constructor(props) {
        super(props)
        this.useMercadoPagoWorkflow = this.props.location.pathname === '/sign-up-mp'
        this.state = {
            captcha: true,
            loading: false,
            termsAndConditions:false,
            waitingCaptcha: false
        }
    }

    downloadTyC(){
            window.open("https://liquidando-production-users-bucket.s3.amazonaws.com/public/Liquidando_public/terminos_y_condiciones_liquidando.pdf",'_blank')
    }

    async onSubmit(e) {

        e !== undefined && e.preventDefault()
        this.props.form.validateFieldsAndScroll({first: true}, (err, values) => {
            if (!err) {
                this.setState({loading:true})
                if (this.state.captcha === null) {
                    this.ReCAPTCHA.current.execute()
                    this.setState({
                        waitingCaptcha: true
                    })
                }
                else {
                    // Call captcha token validation API endpoint
                    // API.post(
                    //     'test',
                    //     '/google-captcha',
                    //     {
                    //         body: {
                    //             "token": this.state.captcha
                    //         }
                    //     }
                    // )
                    // .then(response => {
                    //     if (response) {
                            let data = {
                                username: values.email.toLowerCase().replace(/\s+/g, ''),
                                password: values.password,
                                attributes: {
                                    phone_number: values.prefix + values.phone,
                                    given_name: values.given_name,
                                    family_name: values.family_name,
                                }
                            }
                            Auth.signUp(data)
                            .then(data => {
                                this.setState({waitingCaptcha:false})
                                message.success("Cuenta creada correctamente, por favor verifique su email")
                                const url = (this.useMercadoPagoWorkflow) ? '/mp-confirm-email?' : '/confirm-email?';
                                this.props.history.push(url + queryString.stringify({email:values.email.toLowerCase().replace(/\s+/g, '')}))
                            })
                            .catch(error => {
                                console.log(error)
                                switch (error.code){
                                    case 'InvalidParameterException' :
                                        message.error('La contraseña debe tener una longitud minima de 8 caracteres entre números y letras',5)
                                        this.ReCAPTCHA.current.reset()
                                        this.setState({captcha:null,loading:false})
                                        break;

                                    case 'InvalidPasswordException':
                                        message.error('La contraseña debe tener una longitud minima de 8 caracteres entre números y letras',5)
                                        this.ReCAPTCHA.current.reset()
                                        this.setState({captcha:null,loading:false})
                                        break;

                                    case 'UsernameExistsException':
                                        message.error('Ya existe un usuario registrado con tu mail. Intenta recuperar tu contraseña',5)
                                        this.ReCAPTCHA.current.reset()
                                        this.setState({captcha:null,loading:false})
                                        break;

                                    case 'CodeDeliveryFailureException':
                                        message.error('No pudimos enviar el código de verificación al correo indicado. Por favor, reintenta con otro mail',5)
                                        this.ReCAPTCHA.current.reset()
                                        this.setState({captcha:null,loading:false})
                                        break;

                                    default:
                                        message.error('No pudimos procesar tu solicitud. Por favor, reintenta mas tarde. Codigo: '+error.code,5)
                                        this.ReCAPTCHA.current.reset()
                                        this.setState({captcha:null,loading:false})
                                        break;
                                }

                            })
                        // }
                        // else {
                        //     message.error("Error en la validación del captcha")
                        //     this.setState({captcha:null,loading:false})
                        //     this.ReCAPTCHA.current.reset()
                        //     this.ReCAPTCHA.current.execute()
                        // }
                    // })
                    // .catch(err => console.log(err))
                }
            }
        })
    }

    ReCAPTCHA = React.createRef();

    onCaptcha(value) {
        this.setState({
            captcha: value
        })
        if ( this.state.waitingCaptcha ) {
            this.onSubmit()
        }
    }

    compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('password')) {
            callback('Las contraseñas no coinciden');
        } else {
            callback();
        }
    };

    validateToNextPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value) {
            form.validateFields(['confirm_password'], { force: true });
        }
        callback();
    };

    render() {

        const { getFieldDecorator } = this.props.form;

        const prefixSelector = (
            <Form.Item style={{height: 20}}>
                {
                    getFieldDecorator('prefix', {
                        initialValue: "+54",
                        rules: [
                            {
                                required: true,
                                message: "Prefijo necesario"
                            }
                        ]
                    })(
                        <Select
                            style={{ width: 130, marginBottom:'10px', marginTop:'0px', paddingTop:'0px'}}
                        >
                        <Select.Option value="+54">
                            ARG (+54)
                        </Select.Option>
                        <Select.Option value="+55">
                            BRA (+55)
                        </Select.Option>
                        <Select.Option value="+598">
                            URU (+598)
                        </Select.Option>
                        <Select.Option value="+56">
                            CHI (+56)
                        </Select.Option>
                        <Select.Option value="+595">
                            PAR (+595)
                        </Select.Option>

                        </Select>
                    )
                }
            </Form.Item>
        );

        if (this.props.login.fechingStatus === true){
            return null;
        }
        else if (this.props.login.calling === false && this.props.login.auth === true ) {
            return <Redirect to="/" />;
        }
        else {

            return (
                <LoginBase title="Registrarse">
                    <Form
                        onSubmit={(e)=>this.onSubmit(e)}
                        hideRequiredMark={true}
                        style={{margin:"10px"}}
                    >
                        <Form.Item
                        >
                            {
                                getFieldDecorator('given_name', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Nombre requerido',
                                        }
                                    ]
                                })(<Input
                                    prefix={<Icon type="user" />}
                                    placeholder="Nombre"
                                    autoComplete="given-name"
                                />)
                            }
                        </Form.Item>
                        <Form.Item>
                            {
                                getFieldDecorator('family_name', {
                                    rules: [
                                        {
                                            required: true,
                                            message: 'Apellido requerido',
                                        },
                                    ]
                                })(<Input
                                    prefix={<Icon type="user" />}
                                    placeholder="Apellido"
                                    autoComplete="family-name"
                                />)
                            }
                                </Form.Item>

                        <Form.Item>
                        {
                            getFieldDecorator('email', {
                                rules: [
                                    {
                                        type: 'email',
                                        message: 'Email válido requerido',
                                    },
                                    {
                                        required: true,
                                        message: 'Email requerido',
                                    },
                                ]
                            })(<Input
                                    prefix={<Icon type="mail" />}
                                    placeholder="E-mail"
                                    suffix={
                                        <Tooltip title="Ingrese su email">
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                    }
                                    autoComplete="email"
                                    autoFocus
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                        {
                            getFieldDecorator('phone', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Teléfono requerido',
                                    }
                                ]
                            })(<Input
                                    addonBefore={prefixSelector}
                                    type="tel"
                                    prefix={<Icon type="phone" />}
                                    placeholder="Teléfono"
                                    suffix={
                                        <Tooltip title="Cod. Area sin 0 y sin 15. Ej: 3416664141">
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                    }
                                    autoComplete="tel-national"
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                        {
                            getFieldDecorator('password', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Contraseña requerida',
                                    },
                                    {
                                        validator: this.validateToNextPassword
                                    }
                                ],
                            })(<Input.Password
                                    prefix={<Icon type="lock" />}
                                    placeholder="Nueva constraseña"
                                    type="password"
                                    autoComplete="new-password"
                                />)
                        }
                        </Form.Item>
                        <Form.Item>
                        {
                            getFieldDecorator('confirm_password', {
                                rules: [
                                    {
                                        required: true,
                                        message: 'Confirmacion de contraseña requerida',
                                    },
                                    {
                                        validator: this.compareToFirstPassword
                                    }
                                ],
                            })(<Input.Password
                                    prefix={<Icon type="lock" />}
                                    placeholder="Confirme la contraseña"
                                    type="password"
                                    autoComplete="new-password"
                                />)
                        }
                        </Form.Item>
                        <ReCAPTCHA
                            sitekey={TEST_SITE_KEY}
                            onChange={(value) => this.onCaptcha(value)}
                            style={{display:"inline-block"}}
                            hl="es"
                            size="invisible"
                            ref={this.ReCAPTCHA}
                        />
                        <Form.Item>
                        {
                            getFieldDecorator('terminos_condiciones', {
                                valuePropName: 'checked',
                                defaultChecked: !this.state.termsAndConditions,
                                initialValue: !this.state.termsAndConditions,
                                value: !this.state.termsAndConditions
                            })
                                (<Checkbox onChange={() => this.setState({termsAndConditions:!this.state.termsAndConditions})} >He leído y acepto los <Button style={{padding:'0px'}} type='link' onClick={this.downloadTyC}><b>Términos y Condiciones</b></Button></Checkbox>)
                        }
                        </Form.Item>
                        <Form.Item>
                            <Button
                                onClick={(e)=>this.onSubmit(e)}
                                className="ant-btn-stepsuser"
                                type="primary"
                                htmlType="submit"
                                loading={this.state.loading}
                                disabled={this.state.termsAndConditions}
                            >
                                Registrarse
                            </Button>
                        </Form.Item>
                        <Form.Item>
                            <Paragraph>¿Ya tenés cuenta? Vé a<Button style={{padding:'0px'}}type="link" onClick={()=>this.props.history.push('/login')}> iniciar sesión</Button></Paragraph>
                        </Form.Item>
                    </Form>
                </LoginBase>
            )
        }
    }
}

const SignUp = Form.create({ name: 'sign-up' })(SignUpForm);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SignUp));
